module.exports = __webpack_public_path__ + "img/zhjq12_image.088fa238.png";